export const GET_CANDIDATE_RESIT_TRANSACTION = 'GET_CANDIDATE_RESIT_TRANSACTION';
export const GET_RESIT_RECEIPT_SUMMARY = 'GET_RESIT_RECEIPT_SUMMARY';
export const GET_RESIT_CANDIDATE_DOWNLOAD_SUMMARY = 'GET_RESIT_CANDIDATE_DOWNLOAD_SUMMARY';
